export default __webpack_public_path__ + "cb0a712.png";